"use strict";
(globalThis["webpackChunktvg_shopify_theme"] = globalThis["webpackChunktvg_shopify_theme"] || []).push([[7305],{

/***/ 502:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7809);
/* harmony import */ var _customer_storefront_repository__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4319);
/* harmony import */ var _customer_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5633);
/* harmony import */ var _theme_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8884);
/* harmony import */ var _core_factories_cart_items_factory__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4708);
/* harmony import */ var _core_google_analytics_events__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6627);







class SidecartRecommendationsController extends _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__.Controller {
  static outlets = [ "sidecart" ]
  static values = {
    subscriptionState: Boolean }
  static targets = [ 'productCard' ]

  subscriptionStateValueChanged() {
    if(this.subscriptionStateValue) {
      this.showSubscriptionPricing()
    } else {
      this.showOtpPricing()
    }
  }

  showSubscriptionPricing() {
    this.productCardTargets.forEach(productCard => {
      productCard.querySelector('[data-price-container]').textContent = `$${productCard.dataset.subscriptionPrice / 100}`
      productCard.querySelector('[data-price-per-cup-container]').textContent = `$${Math.round(productCard.dataset.subscriptionPrice / productCard.dataset.capsulesCount) / 100} per cup`
      productCard.querySelector('[data-analytics-price]').dataset.analyticsPrice = `${productCard.dataset.subscriptionPrice / 100}`
    })
  }

  showOtpPricing() {
    this.productCardTargets.forEach(productCard => {
      productCard.querySelector('[data-price-container]').textContent = `$${productCard.dataset.otpPrice / 100}`
      productCard.querySelector('[data-price-per-cup-container]').textContent = `$${Math.round(productCard.dataset.otpPrice / productCard.dataset.capsulesCount) / 100} per cup`
      productCard.querySelector('[data-analytics-price]').dataset.analyticsPrice = `${productCard.dataset.otpPrice / 100}`
    })
  }

  async addItem(event) {
    const target = event.currentTarget
    const fullVariant = await this.fetchFullVariant(
      target.dataset.productId,
      target.dataset.variantId
    )

    const firstBundleSubscriptionName = this.sidecartOutlet.firstBundleItems()[0]?.sellingPlanAllocation?.sellingPlan?.name
    const matchingSellingPlanId = fullVariant.sellingPlanGroups.nodes[0].sellingPlans.nodes.find(
      sellingPlan => sellingPlan.name === firstBundleSubscriptionName
    )?.id

    const itemsToAdd = _core_factories_cart_items_factory__WEBPACK_IMPORTED_MODULE_4__.CartItemsFactory.create({
      variantId: (0,_customer_utils__WEBPACK_IMPORTED_MODULE_2__.ensureNoGid)(fullVariant.id),
      productId: (0,_customer_utils__WEBPACK_IMPORTED_MODULE_2__.ensureNoGid)(target.dataset.productId),
      quantity: 1,
      sellingPlanId: matchingSellingPlanId,
      source: 'customer',
      bundleItems: [{
        variantId: (0,_customer_utils__WEBPACK_IMPORTED_MODULE_2__.ensureNoGid)(fullVariant.id),
        productId: (0,_customer_utils__WEBPACK_IMPORTED_MODULE_2__.ensureNoGid)(fullVariant.product.id),
        quantity: 1,
        sellingPlanId: matchingSellingPlanId,
      }],
      bundleProductHandle: 'build-your-own-box',
      bundleCollectionId: '473755812139',
      bundleProductId: _theme_constants__WEBPACK_IMPORTED_MODULE_3__.COFFEE_BUNDLE_PRODUCT_ID,
      bundleVariantId: '48081770709291'
    })
    const cartAdditionResult = await this.sidecartOutlet.addItems(itemsToAdd)

    this.sidecartOutlet.fetchCart()
    this.sidecartOutlet.scrollToTop()

    if (cartAdditionResult && cartAdditionResult.items.length > 0) {
      this.fireRecommendationAddedEvent(cartAdditionResult)
      this.fireGAAddToCartEvent(cartAdditionResult, target)
    }
  }

  // Helper to fetch full variant data from getProduct
  async fetchFullVariant(productId, variantId) {
    let variant

    const product = await _customer_storefront_repository__WEBPACK_IMPORTED_MODULE_1__["default"].getProduct(productId)

    variant = product.variants.edges.find(e => e.node.id == (0,_customer_utils__WEBPACK_IMPORTED_MODULE_2__.ensureGid)("ProductVariant", variantId)).node
    // Need to reference the product and selling plan groups later, so let's carry them over
    variant.product = product
    variant.sellingPlanGroups = product.sellingPlanGroups

    return variant
  }

  fireGtag(eventName, detail) {
    window.gtag('event', eventName, detail)
  }

  fireRecommendationAddedEvent(cartAdditionResult) {
    const addedLineItem = cartAdditionResult.items[0]
    const detail = {
      productId: addedLineItem.product_id,
      variantId: addedLineItem.variant_id,
      price: addedLineItem.price,
      subscriptionToggle: this.subscriptionStateValue,
    }

    this.fireGtag("Sidecart Recommendation Added", detail)
  }

  fireGAAddToCartEvent(cartAdditionResult, target) {
    const item = cartAdditionResult.items[0]
    const position = Array.from(this.element.querySelectorAll('[data-action="sidecart-recommendations#addItem"]:not(.hidden)')).indexOf(target)
    
    ;(0,_core_google_analytics_events__WEBPACK_IMPORTED_MODULE_5__.fireAddToCartEvent)(item.product_id, item.variant_id, item.price, "Sidecart Recommendation", position + 1)
  }
}

Stimulus.register("sidecart-recommendations", SidecartRecommendationsController)


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [2333], () => (__webpack_exec__(502)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);